import React, { lazy, Suspense, useMemo } from 'react'

import {
  SVGInlineWrapper,
  SVGWrapper,
} from 'scripts/components/SVGs/custom.styled'

export default function SVG({
  icon,
  isInline = true,
  iconColor = '',
  type = 'hsf',
  useWrapper = true,
  lazy = true,
  ...props
}) {
  const IconComponent = icon
    ? lazy
      ? getIconLazy(type, icon)
      : getIcon(type, icon)
    : false

  const inner = lazy ? (
    <Suspense fallback={null}>
      <IconComponent />
    </Suspense>
  ) : (
    <IconComponent.default />
  )

  if (!useWrapper) {
    return inner
  }

  return IconComponent
    ? React.createElement(
        isInline ? SVGInlineWrapper : SVGWrapper,
        {
          ...props,
          type,
          className: ['dhsv-svg', icon, props.className || false]
            .filter(Boolean)
            .join(' '),
          style: {
            ...props.style,
            '--icon-accent': iconColor || '',
          },
        },
        inner
      )
    : null
}

const getIcon = (type, icon) => {
  try {
    return require(`./lib/${getPath(type)}/${icon}.js`)
  } catch (err) {
    console.log(`not found ${icon} of type ${type}`) //eslint-disable-line
    return false
  }
}

const getIconLazy = (type, icon) => {
  try {
    return useMemo(
      () =>
        lazy(() =>
          import(
            /* webpackChunkName: "icon-[request]" */
            `./lib/${getPath(type)}/${icon}.js`
          ).catch(e => {
            console.error(e) //eslint-disable-line
            return { default: () => null }
          })
        ),
      [icon, type]
    )
  } catch (err) {
    console.log(`not found ${icon} of type ${type}`) //eslint-disable-line
    return false
  }
}

const getPath = type => {
  switch (type) {
    case 'axa':
      return 'axa-icons'
    case 'ion':
      return 'ion-icons'
    case 'theme':
      return 'theme'
  }
}
